import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LocalService, PageKey } from '../../../service/local.service';

@Component({
  selector: 'app-users-access',
  templateUrl: './users-access.component.html',
  styleUrls: ['./users-access.component.scss']
})
export class UsersAccessComponent implements OnInit {

  constructor(public localService: LocalService, public configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.UsersAccess);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  onLoad() {

  }
}
